import { styled } from "@mui/material";

export const ScrollButtons = styled("div")`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
`;
